var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTips = function SvgTips(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3033,
    cy: 14.6133,
    r: 14,
    fill: "#FF5E6D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_893_84087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6488 12.4812C16.6488 12.2223 16.4382 12.0117 16.1793 12.0117C15.9205 12.0117 15.7099 12.2223 15.7099 12.4812C15.7099 12.7401 15.9205 12.9507 16.1793 12.9507C16.4382 12.9507 16.6488 12.7401 16.6488 12.4812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8964 12.4812C12.8964 12.2223 12.6858 12.0117 12.4269 12.0117C12.1681 12.0117 11.9574 12.2223 11.9574 12.4812C11.9574 12.7401 12.1681 12.9507 12.4269 12.9507C12.6858 12.9507 12.8964 12.7401 12.8964 12.4812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8341 13.8867H14.7731V18.8602H13.8341V13.8867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3032 6.61328C11.068 6.61328 8.43595 9.24531 8.43595 12.4805C8.43595 13.5031 8.70317 14.5101 9.20873 15.3926C9.6546 16.171 10.2773 16.8409 11.0197 17.3433V18.861H12.8962V13.8875H12.4267C11.6509 13.8875 11.0197 13.2563 11.0197 12.4805C11.0197 11.7047 11.6509 11.0735 12.4267 11.0735C13.2025 11.0735 13.8337 11.7047 13.8337 12.4805C13.8337 12.6451 13.805 12.8031 13.7528 12.95H14.8535C14.8014 12.8031 14.7727 12.6451 14.7727 12.4805C14.7727 11.7047 15.4039 11.0735 16.1797 11.0735C16.9555 11.0735 17.5867 11.7047 17.5867 12.4805C17.5867 13.2563 16.9555 13.8875 16.1797 13.8875H15.7102V18.861H17.5867V17.3433C18.329 16.8409 18.9518 16.171 19.3976 15.3926C19.9032 14.5101 20.1704 13.5031 20.1704 12.4805C20.1704 9.24531 17.5384 6.61328 14.3032 6.61328V6.61328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0199 21.6758H17.5869V22.614H11.0199V21.6758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0199 19.7988H17.5869V20.7378H11.0199V19.7988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_893_84087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6.30327 6.61328)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTips);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tips.abb9f26044efad0c7ad3554b61795ca6.svg";